module.exports = __webpack_public_path__ + "img/default-tornado.e523b48d.svg";